<template>
  <div class="cps">
    <!-- @click="openQQ" -->
    <!-- <img style="cursor: pointer; width: 100%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/fourth_year.png" alt="" /> -->
    <!-- <img style="cursor: pointer; width: 100%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" /> -->
    <!-- <div class="content-center">
      <img style="cursor: pointer; width: 60%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" />
    </div> -->

    <div>
      <div class="content-center">
        <div  style="font-weight: bold; font-size: 30px; padding: 20px;text-align: right;" >
          <div style="display: flex; justify-content: end">
            <div class="content-center" style="width: 60%;">
              <div class="content-center" style="margin-right: 10px;">新客活动</div>
              <el-button type="primary" size="mini" @click="toRegister" v-if="!userToken" class="breathing">立即注册享优惠</el-button>
              <el-button type="primary" size="mini" @click="toCompany" v-else-if="userToken && userData && userData.companyStatus !=20" class="breathing">立即认证享优惠</el-button>
              <el-button type="primary" size="mini" @click="toCps" v-else-if="tableData && tableData.length > 0" class="breathing">立即发单享优惠</el-button>
            </div>
          </div>
          

          <!-- <div style="display: flex; justify-content: end;margin-bottom: 10px;text-align: center;">
            <div style="width: 60%;" class="flex">
              <div class="content-center" style="width: 60%;">新客活动</div>
              <el-button type="primary" size="mini" @click="toRegister" v-if="!userToken">立即注册享优惠</el-button>
              <el-button type="primary" size="mini" @click="toCompany" v-if="userToken && userData && userData.companyStatus !=20">立即认证享优惠</el-button>
            </div>
            
          </div> -->
          <!-- <div style="display: flex; justify-content: end;" v-if="!userToken">
            <div class="content-center" style="width: 60%;"><el-button type="primary" size="mini" @click="toRegister">立即注册享优惠</el-button></div>
          </div>
          <div style="display: flex; justify-content: end;width: 60%;" v-if="userToken && userData && userData.companyStatus !=20">
            <el-button type="primary" size="mini" @click="toCompany" >立即认证享优惠</el-button>
          </div> -->
          <div style="margin-top: 10px;">
            <img style="width: 60%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/active2.png" alt="" />
          </div>
        </div>
        <div style="font-weight: bold; font-size: 30px; padding: 20px;text-align: left">
          <div class="content-center" style="width: 60%;margin-bottom: 10px;">
            <div style="margin-right: 10px;">充赠活动</div>
            <el-button type="primary" size="mini" @click="toRegister" v-if="!userToken" class="breathing">立即登录享优惠</el-button>
            <el-button type="primary" size="mini" @click="toUserPay" v-else class="breathing">立即充值享优惠</el-button>
          </div>
          <!-- <div class="content-center" style="width: 60%;" >
            <el-button type="primary" size="mini" @click="toRegister" v-if="!userToken">请先登录</el-button>
          </div>
          <div class="content-center" style="width: 60%;" v-else>
            <el-button type="primary" size="mini" @click="toUserPay" v-else>前往充赠页面</el-button>
          </div> -->
          <div style="margin-top: 10px;">
            <img style="width: 60%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/active1.png" alt="" />
          </div>
        </div>
      </div>
      
    </div>

    <div>
      <!-- <div></div> -->
    </div>
      <!-- <img style="cursor: pointer; width: 80%" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home-banner10.png" alt="" /> -->
    </div>
  </div>
</template>

<script>
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
import { activityOrderStatistic, burialPoint, fetchUserInfo } from '@/api/user'
import router from '@/router'

export default {
  name: 'cps',
  data() {
    return {
      numUrl: `${ossUrl}/common/introduce/number-1.png`,
      tableData: [],
      userToken: '',
      userData: ''
    }
  },
  created() {
    this.userToken = localStorage.getItem('userToken')
    
    if(this.userToken && this.userToken != null){
      this.getActivity()
    }

  },
  methods: {
    openQQ,
    toRegister(){
      burialPoint('/eventsPage/yonghuzhuce') // 用户注册
      router.push('/user/register')
    },
    toCps(){
      burialPoint('/eventsPage/cps') // 
      router.push('/cps/?type=DRAFT')
    },
    toCompany(){
      burialPoint('/eventsPage/yonghurenzheng') // 用户认证
      router.push('/user/company/certification')
    },
    toUserPay(){
      burialPoint('/eventsPage/yonghuchongzhi') 
      router.push('/user/finance/balance')
    },
    getActivity() {
      activityOrderStatistic().then(res => {
        this.tableData = res.data
      })
      fetchUserInfo().then(res => {
        this.userData = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cps {
  display: flex;
  align-items: center;
  justify-content: center;

  // 居中
  .content-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-div {
    margin-bottom: 5px;
  }

  // .breathing {
  //   animation: breathing 2s ease-in-out infinite;
  // }
  .breathing {
    animation: breathing 2s infinite; /* 设置动画名称为"breathing"，持续时间为2秒，无限次重复 */
  }

  @keyframes breathing {
    0% {
      transform: scale(1);
    } /* 初始状态，不放大或缩小 */
    50% {
      transform: scale(1.2);
    } /* 在动画进行到一半时，将文字放大一些 */
    100% {
      transform: scale(1);
    } /* 结束状态，还原为正常大小 */
  }
}
</style>
